// extracted by mini-css-extract-plugin
export default {"steps":"ReadSteps_steps__RhTEK","step":"ReadSteps_step__7wEVA"};